import { User } from '@/api/types/public';
import { ProviderType, TrackingEvent } from '../types';

export function signupAdapter(
  data: { userInfo: User; registerType?: 'email' | 'fast_register' },
  provider: ProviderType,
): TrackingEvent | TrackingEvent[] | null {
  const { userInfo, registerType } = data;
  switch (provider) {
    case ProviderType.EMARSYS:
      return {
        eventName: 'signup',
        properties: {
          uuid: `${userInfo?.id}`,
        },
      };
    case ProviderType.SNAPCHAT:
      return {
        commandType: 'track',
        eventName: 'SIGN_UP',
        properties: {},
      };
    case ProviderType.SNAPCHAT_CONVERSION:
      return {
        commandType: 'track',
        eventName: 'SIGN_UP',
        properties: {},
      };
    case ProviderType.FACEBOOK:
      return {
        eventName: 'CompleteRegistration',
        properties: {},
      };
    case ProviderType.TIKTOK: {
      const ttqEventId = `reg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      return {
        eventName: 'Registration',
        properties: {
          event_id: ttqEventId,
        },
      };
    }
    case ProviderType.APPLOVIN: {
      const aleid = localStorage.getItem('zl_axon_aleid');
      return [
        {
          eventName: 'sign_up',
          properties: {
            method: 'email',
            user_id: `${userInfo.id}`,
          },
        },
        {
          eventName: 'generate_lead',
          properties: {
            user_id: `${userInfo.id}&${aleid}`,
          },
        },
      ];
    }
    case ProviderType.TWITTER:
      return [
        {
          eventName: 'tw-of32e-of32o',
          properties: {},
        },
        {
          eventName: 'tw-of2hc-of326',
          properties: {},
        },
      ];
    case ProviderType.GA4:
      return {
        commandType: 'event',
        eventName: 'sign_up',
        properties: {
          event_label: 'register',
          event_category: registerType || 'email',
        },
      };
    case ProviderType.BING:
      return {
        eventName: 'buttonclick',
        properties: { event_category: 'register', event_label: 'click', event_value: '1' },
      };
    default:
      return null;
  }
}
